"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRibbonContext = exports.RibbonContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Ribbon_1 = __importDefault(require("./Ribbon"));
exports.RibbonContext = react_1.createContext({ openRibbon: function () { } });
var RibbonProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(), ribbonState = _b[0], setRibbonState = _b[1];
    var onRibbonClick = react_1.useCallback(function () {
        if (ribbonState === null || ribbonState === void 0 ? void 0 : ribbonState.onClick) {
            ribbonState === null || ribbonState === void 0 ? void 0 : ribbonState.onClick();
            onRibbonClose();
        }
    }, [ribbonState]);
    var onRibbonClose = function (event) {
        if (event)
            event.stopPropagation();
        setRibbonState(undefined);
    };
    var openRibbon = react_1.useCallback(function (state) {
        setRibbonState(__assign(__assign({}, state), { component: state.manual ? jsx_runtime_1.jsx(Ribbon_1.default, { state: state, onClick: state.onClick, onClose: onRibbonClose }, void 0) : undefined }));
    }, []);
    return (jsx_runtime_1.jsxs(exports.RibbonContext.Provider, __assign({ value: { openRibbon: openRibbon, component: ribbonState === null || ribbonState === void 0 ? void 0 : ribbonState.component } }, { children: [(ribbonState === null || ribbonState === void 0 ? void 0 : ribbonState.message) && !ribbonState.manual && (jsx_runtime_1.jsx(Ribbon_1.default, { state: ribbonState, onClick: onRibbonClick, onClose: onRibbonClose }, void 0)), children] }), void 0));
};
var useRibbonContext = function () { return react_1.useContext(exports.RibbonContext); };
exports.useRibbonContext = useRibbonContext;
exports.default = RibbonProvider;
